import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import ClientUtils from "../../utils/ClientUtils";
import withIconSize from "./hoc/withIconSize";
import { InternalIconProps } from "./types/SvgIconProps";

interface Props extends InternalIconProps {
  className?: string;
}

const AppCustomerSignIcon = (props: Props) => {
  const { className, ...rest } = props;

  return (
    <ClipboardDocumentListIcon
      {...rest}
      className={ClientUtils.twClassNames("", props.className)}
    />
  );
};
export default withIconSize(AppCustomerSignIcon);
